import { useCallback } from "react";
import type { RegisteredEntity } from "@newrelic/browser-agent/interfaces/registered-entity";

type UseNewRelicReturn = Pick<RegisteredEntity, "addPageAction" | "recordCustomEvent" | "setCustomAttribute">;

export const useNewRelic = (): UseNewRelicReturn => {
  const nr = window.newrelic;

  const addPageAction = useCallback<UseNewRelicReturn["addPageAction"]>(
    (name, attributes) => {
      if (nr) {
        nr.addPageAction(name, attributes);
      }
    },
    [nr]
  );

  const recordCustomEvent = useCallback<UseNewRelicReturn["recordCustomEvent"]>(
    (name, attributes) => {
      if (nr) {
        nr.recordCustomEvent(name, attributes);
      }
    },
    [nr]
  );

  const setCustomAttribute = useCallback<UseNewRelicReturn["setCustomAttribute"]>(
    (key, value) => {
      if (nr) {
        nr.setCustomAttribute(key, value);
      }
    },
    [nr]
  );

  return {
    addPageAction,
    recordCustomEvent,
    setCustomAttribute
  };
};
